/**
 * Privacy Policy Page (v0.10.0 - Issue #386)
 *
 * Clean, honest privacy policy for all users.
 * Content lives in data/content/privacy.ts (#2212 — shared with the
 * native Privacy screen).
 */

import PageLayout from '../components/PageLayout';
import ContentDocView from '../components/ContentDocView';
import { PRIVACY_DOC } from '../data/content/privacy';

export default function PrivacyPage() {
  return (
    <PageLayout title="Privacy">
      <ContentDocView doc={PRIVACY_DOC} />
    </PageLayout>
  );
}
